// Feature flags and app config
export const PAYMENTS_ENABLED = process.env.REACT_APP_PAYMENTS_ENABLED === "true";

export const REGISTRATION_EMAIL = "hadafsportscanada@gmail.com";

/** Must match the email in the `public.is_admin()` Postgres function; RLS is the real gate. */
export const ADMIN_EMAIL = "hadafsportscanada@gmail.com";
